import useBaseMessageAsyncError from './useBaseMessageAsyncError';
import useSnackbar from './useSnackbar';

function useMessangerAsyncError() {
  return useBaseMessageAsyncError({ hook: useSnackbar });
}

export default useMessangerAsyncError;
